/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceNodeStatusDto
 */
export interface ResourceNodeStatusDto {
    /**
     * The name of the node.
     * @type {string}
     * @memberof ResourceNodeStatusDto
     */
    name: string;
    /**
     * Indicates if the node can be used.
     * @type {boolean}
     * @memberof ResourceNodeStatusDto
     */
    isReady: boolean;
    /**
     * The message to describe the status.
     * @type {string}
     * @memberof ResourceNodeStatusDto
     */
    message: string | null;
}

/**
 * Check if a given object implements the ResourceNodeStatusDto interface.
 */
export function instanceOfResourceNodeStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "isReady" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ResourceNodeStatusDtoFromJSON(json: any): ResourceNodeStatusDto {
    return ResourceNodeStatusDtoFromJSONTyped(json, false);
}

export function ResourceNodeStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceNodeStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'isReady': json['isReady'],
        'message': json['message'],
    };
}

export function ResourceNodeStatusDtoToJSON(value?: ResourceNodeStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'isReady': value.isReady,
        'message': value.message,
    };
}

